import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
import { TweenLite, Linear, TimelineLite, TweenMax, Power3 } from 'gsap';

const $timeline = $('.js-timeline');
const $action = $('.js-timeline-action');
const $imageCarousel = $('.js-timeline-image-carousel');


export const initCarousel = () => {
	if (!$imageCarousel.length) {
		return;
	}

	$imageCarousel.each((i, elem) => {
		$(elem).slick({
			adaptiveHeight: true,
			arrows: true,
			cssEase: 'ease-in-out',
			draggable: true,
			lazyLoad: 'progressive',
			slidesToShow: 1,
			speed: 300,
			touchThreshold: 10,
			responsive: [
				{
					breakpoint: 1025,
					settings: {
						arrows: true,
					},
				},
			],
		});
	});
};

export const initMainSpine = () => {
	const $spine = $('.js-timeline-spine-main');
	const $marker = $('.js-timeline-marker');

	if ($marker.length === 0) {
		console.warn('No markers found');
		return;
	}

	const firstPoint = $marker.first().offset();
	const lastPoint = $marker.last().offset();

	if (!firstPoint || !lastPoint) {
		console.warn('Unable to retrieve offset');
		return;
	}

	const distance = lastPoint.top - firstPoint.top;

	$spine.height(distance);
};

export const initSectionSpine = () => {
	const $spine = $('.js-timeline-spine-section');

	$spine.each((i, elem) => {
		const $section = $(elem).closest('.js-timeline-section');
		const $markers = $section.find('.js-timeline-marker');
		const firstPoint = $markers.first().offset().top;
		const lastPoint = $markers.last().offset().top;
		const distance = lastPoint - firstPoint;

		$(elem).height(distance);
	});
};

export const initMarkerHorizontalPosition = () => {
	const $markers = $('.js-timeline-marker');
	const windowWidth = $(window).width();
	const half = windowWidth / 2;

	if (windowWidth <= 800) {
		$markers.each((i, elem) =>
			$(elem)
			.removeAttr('style')
			.removeClass('js-marker-hide')
			);
		return;
	}
	$markers.each((i, elem) => {
		const $marker = $(elem);

		$marker.removeAttr('style');

		const markerLeft = $marker.offset().left;
		const difference = markerLeft - half;
		const modifier = $marker.width() / 2;

		const left = difference > 0 ? `-${difference + modifier}px` : `${Math.abs(difference + modifier)}px`;

		$marker.css({
			left,
		});
		$marker.removeClass('js-marker-hide');
	});
};

/* eslint-disable no-console */
export function runAnimateIn() {
	const controller = new ScrollMagic.Controller();
	const $triggerElement = $('.js-animate-in-target');
	$triggerElement.each((i, el) => {
		if ($(el).hasClass('js-timeline-card')) {
			const id = `#${$(el).attr('id')}`;
			const sceneTimeline = new ScrollMagic.Scene({
				triggerElement: el,
				triggerHook: 0,
				duration: 201,
				offset: -100,
			});
			sceneTimeline
			.setClassToggle(id, 'timeline-card--active')
			.addTo(controller);
		}
		const scene = new ScrollMagic.Scene({
			triggerElement: el,
			triggerHook: 1,
		});
		scene
		.on('start', () => {
			const target = '.js-animate-in-element';
			const duration = 0.8;
			const ease = Power3.easeInOut;
			const delay = 0.1;
			TweenMax.staggerTo(
				$(el).find(target),
				duration,
				{ y: 0, opacity: 1, ease },
				delay
				);
		})
		.reverse(false)
		.addTo(controller);
	});
}

let resizer;

const init = async () => {
  initCarousel();
  initMainSpine();
  initSectionSpine();
  initMarkerHorizontalPosition();

	$(window).resize(() => {
		if ($(window).width() > 800) {
			$('.js-timeline-marker').addClass('js-marker-hide');
		}
		clearTimeout(resizer);
		resizer = setTimeout(() => {
		initMarkerHorizontalPosition();
			initMainSpine();
			initSectionSpine();
		}, 100);
	});

	setTimeout(runAnimateIn, 1200);
};


export default init;
